var _path, _ellipse, _g, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 145,
    viewBox: "0 0 146 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.0002 121.462C106.505 121.462 133.623 94.5804 133.623 61.4136C133.623 28.2468 106.505 1.46191 73.0002 1.46191C39.5936 1.46191 12.377 28.3435 12.377 61.5103C12.377 94.6771 39.5936 121.462 73.0002 121.462Z",
    fill: "#1C2538"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.6258,
    cy: 30.2662,
    rx: 2.36997,
    ry: 2.33549,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2994_30822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.399 111.527H28.4366C25.1212 111.527 22.3584 108.827 22.3584 105.588V17.0398C22.3584 13.8002 25.1212 11.1006 28.4366 11.1006H117.399C120.714 11.1006 123.477 13.8002 123.477 17.0398V105.588C123.477 108.827 120.714 111.527 117.399 111.527Z",
    fill: "#6F778A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9006 44.2801C78.8813 44.2801 84.5404 38.7033 84.5404 31.8241C84.5404 24.9449 78.8813 19.3682 71.9006 19.3682C64.9198 19.3682 59.2607 24.9449 59.2607 31.8241C59.2607 38.7033 64.9198 44.2801 71.9006 44.2801Z",
    fill: "#474E61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9011 32.6027C74.5189 32.6027 76.641 30.5114 76.641 27.9317C76.641 25.352 74.5189 23.2607 71.9011 23.2607C69.2833 23.2607 67.1611 25.352 67.1611 27.9317C67.1611 30.5114 69.2833 32.6027 71.9011 32.6027Z",
    fill: "#989FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9861 40.3919C78.6942 42.7887 75.4712 44.2806 71.9013 44.2806C68.3313 44.2806 65.1083 42.7887 62.8164 40.3919C64.0819 36.7712 67.6712 34.1602 71.9013 34.1602C76.1314 34.1602 79.7206 36.7712 80.9861 40.3919Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.164 63.4498H34.3094C33.4027 63.4498 32.4961 62.4567 32.4961 61.4635V52.5253C32.4961 51.5322 33.4027 50.5391 34.3094 50.5391H110.164C111.071 50.5391 111.977 51.5322 111.977 52.5253V61.4635C111.977 62.4567 111.071 63.4498 110.164 63.4498Z",
    fill: "#474E61"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.7363,
    y: 55.7031,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9766,
    y: 55.7031,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.2178,
    y: 55.7031,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.458,
    y: 55.7031,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8252,
    y: 55.7031,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0654,
    y: 55.7031,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.494 82.6217H33.6394C32.7328 82.6217 31.8262 81.6285 31.8262 80.6354V71.6972C31.8262 70.7041 32.7328 69.7109 33.6394 69.7109H109.494C110.401 69.7109 111.307 70.7041 111.307 71.6972V80.6354C111.307 81.6285 110.401 82.6217 109.494 82.6217Z",
    fill: "#474E61"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0664,
    y: 74.875,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.3066,
    y: 74.875,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5479,
    y: 74.875,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7881,
    y: 74.875,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1553,
    y: 74.875,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3955,
    y: 74.875,
    width: 2.62026,
    height: 2.58214,
    rx: 1.29107,
    fill: "#AAB2C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.335 102.828C108.185 102.828 111.307 99.7059 111.307 95.8552C111.307 92.0045 108.185 88.8828 104.335 88.8828C100.484 88.8828 97.3623 92.0045 97.3623 95.8552C97.3623 99.7059 100.484 102.828 104.335 102.828Z",
    fill: "#474E61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.187 93.9427L103.238 98.892L100.482 96.1363L101.607 95.0119L103.238 96.6433L107.063 92.8184L108.187 93.9427Z",
    fill: "#9EA6BC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2994_30822",
    x: 0.358398,
    y: 0.100586,
    width: 145.118,
    height: 144.426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2994_30822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2994_30822",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.529c706e7412bca44a94c5bcd81cdf2c.svg";
export { ForwardRef as ReactComponent };